// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import generateUUID from "includes/UUID";

export default class FormOptionModel {

	constructor(obj, parent) {
		let date = formatDate();

		this.parent = parent;
		this.optionId = (obj?.optionId || obj?.id || null);
		this.questionId = (obj?.questionId || null);
		this.formId = (obj?.formId || null);
		this._value = (obj?.value || "");
		this.minValue = (obj?.minValue || 0);
		this.maxValue = (obj?.maxValue || 0);
		this.intervalValue = (obj?.intervalValue || 0);
		this.imgUrl = (obj?.imgUrl || null);
		this.isValid = (obj?.isValid || 0);
		this.isFreeAnswer = (obj?.isFreeAnswer ? obj.isFreeAnswer : true);
		this.position = (obj?.position || 0);
		this.lastChanged = (obj?.lastChanged || date);
		this.lastChangedAuthorId = (obj?.lastChangedAuthorId || null);

		this.tempId = (obj?.tempId || generateUUID());
	}

	send() {
		let prom = new Promise((resolve, reject) => {
			this.sendOption()
				.then(() => {
					resolve (true);
				}, reject);
		});
		return (prom);
	}

	sendOption() {
		let that = this;
		let req = genRequest(
			"forms/options" + (this.optionId ? "/" + this.optionId : ""),
			this.values(),
			(this.optionId ? "put" : "post")
		)
			.then((resp) => {
				if (!that.optionId)
					that.id = resp.id || resp.optionId;
			});
		return (req);
	}

	order(new_pos) {
		if (new_pos)
			this.position = new_pos;
		return (this.position);
	}

	delete() {
		this.parent.removeOption(this.id);
	}

	values() {
		let obj = {
			formId: this.formId,
			questionId: this.questionId,
			position: this.position,
			value: this._value,
			minValue: this.minValue,
			maxValue: this.maxValue,
			intervalValue: this.intervalValue,
			imgUrl: this.imgUrl,
			isValid: this.isValid,
			isFreeAnswer: this.isFreeAnswer,
			lastChanged: this.lastChanged,
			lastChangedAuthorId: this.lastChangedAuthorId,
		};
		if (this.optionId)
			obj.optionId = this.optionId;
		return (obj);
	}

	value(new_val) {
		if (typeof new_val !== "undefined")
			this._value = new_val;
		return (this._value);
	}

	setFormId(value) {
		if (value)
			this.formId = value;
		return (this.formId);
	}

	setQuestionId(value) {
		if (value)
			this.questionId = value;
		return (this.questionId);
	}

	get parentForm() {
		if (!this.parent)
			return (false);
		return (this.parent.parentForm);
	}

	get id() {
		return ((this.optionId ? this.optionId : this.tempId));
	}

	set id(value) {
		if (value)
			this.optionId = value;
	}
}
